/* eslint-disable eqeqeq */
// @ts-nocheck
import { CFormInput, CFormSelect, CSpinner } from "@coreui/react";
import { useEffect, useState } from "react";
import { useMutation, useQueryClient } from "react-query";
import { Link, useNavigate, useParams } from "react-router-dom";

import { yupResolver } from "@hookform/resolvers/yup";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import * as yup from "yup";
import FileUploader from "../../../components/ui/FileUploader";
import { FormSelectAPI } from "../../../components/ui/FormReactSelect";
import InfiniteScrollSelect from "../../../components/ui/InfiniteScrollSelect";
import TimeSelectInput from "../../../components/inputs/TimeSelectInput";
import RichTextEditor from "../../../components/ui/RichTextEditor";
import { FormMode } from "../../../helpers/enums";
import {
  createZoneAwareDate,
  slugify,
  toDateInputValue,
  verifyFileList,
} from "../../../helpers/general";
import { useAuth } from "../../../hooks/useAuth";
import { useCookie } from "../../../hooks/useCookie";
import { useToast } from "../../../hooks/useToast";
import { general } from "../../../locales/general";
import apiService from "../../../service/apiService";
import { useSelectedPlace } from "../../../hooks/place/useSelectedPlace";
import { Field, FormSection } from "../../../components/ui/FormUi";
import { ChipCheck } from "../../../components/ui/ToggleUi"; // adjust path

interface CreateEventProps {
  name: string;
  date: string;
  picture: File;
  startingHour: string;
  endingHour: string;
  description: string;
  address: string;
  typeId: string;
  cityId: string;
  email: string;
  website: string;
  facebookURL: string;
  instagramURL: string;
  tiktokURL: string;
}

export default function NewEvent({ mode = FormMode.CREATE }) {
  const [formLoading, setFormLoading] = useState(false);
  const params = useParams();
  const { isAdmin, user } = useAuth();
  const [isExternalBooking, setIsExternalBooking] = useState(false);
  const [images, setImages] = useState({
    image: "",
  });

  const { selectedPlaceId } = useSelectedPlace(user, isAdmin);

  // const eventDatesSchema = yup.object({
  //   date: yup
  //     .date()
  //     .required("Ce champ est obligatoire")
  //     .typeError("Ce champ est obligatoire")
  //     .transform((_, val) => {
  //       return new Date(val);
  //     }),
  // });

  const schema = yup.object({
    name: yup.string().required("Ce champ est obligatoire"),
    placeId: yup.object().nullable(),
    date: yup
      .date()
      .required("Ce champ est obligatoire")
      .typeError("Ce champ est obligatoire")
      .transform((_, val) => {
        return new Date(val);
      }),
    endDate: yup
      .date()
      .nullable()
      .transform((value, originalValue) => {
        return originalValue === ""
          ? null
          : originalValue
            ? new Date(originalValue)
            : null;
      })
      .test(
        "is-after-start-date",
        "La date de fin doit être postérieure à la date de début",
        function (value) {
          const { date } = this.parent;
          if (!value || !date) return true;

          const startDate = new Date(date).getTime();
          const endDate = new Date(value).getTime();

          return endDate > startDate;
        },
      ),
    picture: yup.mixed().required("Ce champ est obligatoire"),
    startingHour: yup.string().required("Ce champ est obligatoire"),
    endingHour: yup.string().required("Ce champ est obligatoire"),
    hoursToLeaveOpen: yup.string().required("Ce champ est obligatoire"),
    cityId: yup
      .object()
      .required("Ce champ est obligatoire")
      .typeError("Ce champ est obligatoire"),
    address: yup.string().required("Ce champ est obligatoire"),
    typeId: yup
      .object()
      .required("Ce champ est obligatoire")
      .typeError("Ce champ est obligatoire"),
    email: yup
      .string()
      .email("Veuillez entrer un email valide")
      .required("Ce champ est obligatoire"),
    phone: yup.string().required("Ce champ est obligatoire"),
    website: yup.string().url("Veuillez entrer un URL valide").nullable(),
    facebookUrl: yup.string().url("Veuillez entrer un URL valide").nullable(),
    instagramUrl: yup.string().url("Veuillez entrer un URL valide").nullable(),
    tiktokUrl: yup.string().url("Veuillez entrer un URL valide").nullable(),
    venezPercentage: yup
      .number()
      .nullable(true)
      .typeError()
      .transform((_, val) => (val ? Number(val) : null)),
    description: yup.string().nullable(),
    isExternalBooking: yup.string().required("Ce champ est obligatoire"),
    isVisible: yup.string().required("Ce champ est obligatoire"),
    taxiActive: yup.string().optional(),
    externalBookingURL: yup
      .string()
      .ensure()
      .when("isExternalBooking", {
        is: "true",
        then: () =>
          yup
            .string()
            .url("Veuillez entrer un URL valide")
            .required("Ce champ est obligatoire"),
        otherwise: () => yup.string().nullable(),
      }),
    paymentMethodsInPlace: yup.boolean().nullable(),
    paymentMethodsCreditCard: yup.boolean().nullable(),
    paymentMethodsWafacash: yup.boolean().nullable(),
    paymentMethodsBalance: yup.boolean().nullable(),
    ticketsDates: yup.array().of(
      yup
        .date()
        .required("Ce champ est obligatoire")
        .typeError("Ce champ est obligatoire")
        .transform((_, val) => {
          return new Date(val);
        }),
    ),
    latitude: yup.number().when("taxiActive", {
      is: true,
      then: () =>
        yup
          .number()
          .required("Ce champ est obligatoire")
          .min(-90, "Ce champ doit être compris entre -90 et 90")
          .max(90, "Ce champ doit être compris entre -90 et 90")
          .typeError("Ce champ est obligatoire"),
      otherwise: () =>
        yup
          .number()
          .nullable()
          .optional()
          .min(-90, "Ce champ doit être compris entre -90 et 90")
          .max(90, "Ce champ doit être compris entre -90 et 90")
          .typeError("Ce champ est obligatoire")
          .transform((_, val) => {
            const result = val == Number(val) ? Number(val) : null;
            return result;
          }),
    }),
    longitude: yup.number().when("taxiActive", {
      is: true,
      then: () =>
        yup
          .number()
          .required("Ce champ est obligatoire")
          .min(-180, "Ce champ doit être compris entre -180 et 180")
          .max(180, "Ce champ doit être compris entre -180 et 180")
          .typeError("Ce champ est obligatoire"),
      otherwise: () =>
        yup
          .number()
          .nullable(true)
          .optional()
          .min(-180, "Ce champ doit être compris entre -180 et 180")
          .max(180, "Ce champ doit être compris entre -180 et 180")
          .typeError("Ce champ est obligatoire")
          .transform((_, val) => {
            const result = val == Number(val) ? Number(val) : null;
            return result;
          }),
    }),
    addressName: yup.string().when("taxiActive", {
      is: "true" || true,
      then: () => {
        return yup
          .string()
          .transform((_, val: string) => {
            return val?.trim();
          })
          .required("Ce champ est obligatoire");
      },
      otherwise: () => yup.string().nullable(),
    }),
    points: yup.number().default(0).optional(),
    partnerCommission: yup
      .number()
      .min(0)
      .max(100)
      .nullable(true)
      .typeError()
      .transform((_, val) => (val ? Number(val) : null)),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    control: formControl,
    setValue: setFormValue,
    getValues: getFormValue,
    watch: watchFormValue,
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      hoursToLeaveOpen: "00:00",
    },
  });

  // console.log("errors", errors);

  const {
    fields: eventTicketsFields,
    append: appendEventTicketsField,
    remove: removeEventTicketsField,
  } = useFieldArray({
    control: formControl,
    name: "ticketsDates",
  });

  const createNewEventMutation = useMutation(
    async ({ data, duplicate, originalEventId }) => {
      return await apiService.MakePostRequest("events", data, token, true, {
        duplicate,
        originalEventId,
      });
    },
  );

  const updateEventMutation = useMutation(async (data: CreateEventProps) => {
    return await apiService.MakePutRequest(
      `events/${params?.id}`,
      data,
      token,
      true,
    );
  });

  const { token } = useCookie("vToken");
  const { toastError, toastSuccess } = useToast();
  const [description, setDescription] = useState("");
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const taxiActiveValue = watchFormValue("taxiActive");

  useEffect(() => {
    if (
      (mode === FormMode.UPDATE || mode === FormMode.DUPLICATE) &&
      params?.id
    ) {
      apiService
        .MakeGetRequest(`events/${params.id}`, token, {
          mode:
            mode === FormMode.UPDATE || mode === FormMode.DUPLICATE
              ? "edit"
              : "visit",
        })
        .then((response) => {
          const formFields = Object.keys(schema.fields);

          setDescription(response.description);
          setFormValue("placeId", response.place);
          setFormValue("cityId", response.city);
          setFormValue("typeId", response.type);
          setFormValue("picture", response.image);
          const paymentOptions = response.paymentOptions ?? [];
          if (paymentOptions?.includes("in_place")) {
            setFormValue("paymentMethodsInPlace", true);
          }
          if (paymentOptions?.includes("credit_card")) {
            setFormValue("paymentMethodsCreditCard", true);
          }
          if (paymentOptions?.includes("wafacash")) {
            setFormValue("paymentMethodsWafacash", true);
          }
          if (paymentOptions?.includes("stripe")) {
            setFormValue("paymentMethodsStripe", true);
          }
          if (paymentOptions?.includes("user_balance")) {
            setFormValue("paymentMethodsBalance", true);
          }
          setFormValue("points", response?.points);

          setImages({ image: response.image });

          Object.entries(response).forEach(([key, value]) => {
            if (formFields.includes(key)) {
              if (key === "ticketsDates") {
                const ticketsDates = value?.map((ticketDate) =>
                  toDateInputValue(createZoneAwareDate(new Date(ticketDate))),
                );
                setFormValue("ticketsDates", ticketsDates);
              } else if (key === "date") {
                setFormValue(
                  key,
                  toDateInputValue(createZoneAwareDate(new Date(value))),
                );
              } else if (key === "endDate") {
                if (value) {
                  setFormValue(
                    key,
                    toDateInputValue(createZoneAwareDate(new Date(value))),
                  );
                } else {
                  setFormValue(key, ""); // Set empty string for null dates
                }
              } else if (key === "name" && mode === FormMode.DUPLICATE) {
                setFormValue("name", `${value} (copie)`);
              } else {
                setFormValue(key, value);
              }
            }
          });
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const subscription = watchFormValue((value) => {
      setIsExternalBooking(
        value?.isExternalBooking === true ||
          value?.isExternalBooking === "true",
      );
    });

    return () => subscription?.unsubscribe?.();
  }, [watchFormValue]);

  const createEvent = async (data) => {
    try {
      setFormLoading(true);
      const duplicate = mode === FormMode.DUPLICATE;
      const originalEventId = duplicate ? params?.id : undefined;

      await createNewEventMutation.mutateAsync({
        data,
        duplicate,
        originalEventId,
      });

      toastSuccess(general.fr.message.eventCreated);
      navigate(`/events`);
      queryClient.invalidateQueries("getAllEvents");
    } catch (error) {
      console.log(error);
      setFormLoading(false);
      toastError(general.fr.message.operationFailed);
    }
  };

  const updateEvent = async (data) => {
    try {
      // console.log("data to update", data);
      setFormLoading(true);
      await updateEventMutation.mutateAsync(data);
      toastSuccess(general.fr.message.eventUpdated);
      navigate(`/events`);
      queryClient.invalidateQueries("getAllEvents");
    } catch (error) {
      setFormLoading(false);
      toastError(general.fr.message.operationFailed);
    }
  };

  useEffect(() => {
    if (!isAdmin && selectedPlaceId) {
      setFormValue("placeId", { id: selectedPlaceId });
    }
  }, [isAdmin, selectedPlaceId, setFormValue]);

  const onSubmit = async (dataArg) => {
    const data = { ...dataArg };
    const placeId = data.placeId?.id ?? selectedPlaceId;
    try {
      data.slug = slugify(data.name);
      const city = data.cityId;
      data.typeId = data.typeId.id;
      data.cityId = city.id;
      data.placeId = placeId ?? null;
      const pictureFile = verifyFileList(data.picture);
      data.picture = pictureFile;
      data.description = description;
      data.facebookURL = data.facebookUrl;
      data.instagramURL = data.instagramUrl;
      data.tiktokURL = data.tiktokUrl;
      data.date = createZoneAwareDate(data.date);
      if (data.endDate) {
        data.endDate = createZoneAwareDate(data.endDate);
      } else {
        data.endDate = "";
      }
      const paymentOptions = [];
      if (data.paymentMethodsInPlace) {
        paymentOptions.push("in_place");
      }
      if (data.paymentMethodsCreditCard) {
        paymentOptions.push("credit_card");
      }
      if (data.paymentMethodsWafacash) {
        paymentOptions.push("wafacash");
      }
      if (data.paymentMethodsStripe) {
        paymentOptions.push("stripe");
      }
      if (!data?.venezPercentage && data?.venezPercentage !== 0) {
        data.venezPercentage = "null";
      }
      if (data.paymentMethodsBalance) {
        paymentOptions.push("user_balance");
      }
      data.paymentOptions = JSON.stringify(paymentOptions);

      if (data.points) {
        paymentOptions.push("points");
      }

      if (mode === FormMode.DUPLICATE) {
        const fullUrl = getFormValue("picture");
        if (typeof fullUrl === "string" && fullUrl.length > 0) {
          data.image = fullUrl.replace(/^https?:\/\/[^/]+\/events\//, "");
        }
      }
      if (mode === FormMode.UPDATE) {
        updateEvent(data);
      } else {
        createEvent(data);
      }
    } catch (error) {
      setFormLoading(false);
      toastError(general.fr.message.operationFailed);
    }
  };

  const taxiOn = taxiActiveValue === "true" || taxiActiveValue === true;
  const title =
    mode === FormMode.CREATE
      ? "Ajouter un évènement"
      : mode === FormMode.DUPLICATE
        ? "Dupliquer l'évènement"
        : "Modifier l'évènement";

  return (
    <div className="vz-form px-2">
      {/* Header */}
      <div
        style={{
          backgroundColor: "#fff",
          borderRadius: 16,
          padding: "16px 20px",
          boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
        }}
        className="d-flex justify-content-between align-items-center mb-3"
      >
        <div>
          <h4 className="fs-4 fw-bold mb-0">{title}</h4>
          <div className="text-muted" style={{ fontSize: 13 }}>
            Les champs marqués d'une * sont obligatoires
          </div>
        </div>
        <Link
          to="/events"
          className="btn btn-outline-secondary rounded-pill px-3"
        >
          ← Retour
        </Link>
      </div>

      <form onSubmit={handleSubmit(onSubmit)}>
        {/* General */}
        <FormSection title="Informations générales">
          <Field
            label="Nom de l'évènement"
            htmlFor="name"
            required
            error={errors.name?.message}
          >
            <CFormInput
              id="name"
              placeholder="Nom de l'évènement"
              {...register("name")}
            />
          </Field>

          {isAdmin && (
            <Field
              label="Établissement"
              htmlFor="placeId"
              error={errors.placeId?.message}
            >
              <Controller
                name="placeId"
                control={formControl}
                render={({ field }) => (
                  <InfiniteScrollSelect
                    id="placeId"
                    getOptionLabel={(o) => o?.name}
                    getOptionValue={(o) => o.id}
                    isOptionSelected={(o, selected) =>
                      o?.id === selected?.[0]?.id
                    }
                    url={{ path: "places" }}
                    {...field}
                  />
                )}
              />
            </Field>
          )}

          <Field
            label="Type"
            htmlFor="typeId"
            required
            error={errors.typeId?.message}
          >
            <Controller
              name="typeId"
              control={formControl}
              render={({ field }) => (
                <FormSelectAPI
                  id="typeId"
                  isClearable={false}
                  getOptionLabel={(o: EventType) => o?.label}
                  getOptionValue={(o: EventType) => o.id}
                  isOptionSelected={(o: EventType, selected: EventType[]) =>
                    o?.id === selected?.[0]?.id
                  }
                  url={{ path: "events/types" }}
                  {...field}
                />
              )}
            />
          </Field>

          <Field
            label="Image"
            htmlFor="picture"
            required
            error={errors.picture?.message}
          >
            <FileUploader
              id="picture"
              name="picture"
              accept="image/png,image/jpeg,image/jpg,image/JPG,image/PNG,image/JPEG"
              {...register("picture")}
              file={images?.image}
              required={mode === FormMode.CREATE}
            />
          </Field>

          <Field
            label="Visible"
            htmlFor="isVisible"
            required
            error={errors.isVisible?.message}
          >
            <CFormSelect id="isVisible" {...register("isVisible")}>
              <option value="true">Oui</option>
              <option value="false">Non</option>
            </CFormSelect>
          </Field>
        </FormSection>

        {/* Dates & hours */}
        <FormSection title="Dates et horaires">
          <Field
            label="Date de début"
            htmlFor="date"
            required
            error={errors.date?.message}
          >
            <CFormInput id="date" type="date" {...register("date")} />
          </Field>
          <Field
            label="Date de fin"
            htmlFor="endDate"
            error={errors.endDate?.message}
          >
            <CFormInput id="endDate" type="date" {...register("endDate")} />
          </Field>

          <Field
            label="Heure de début"
            required
            error={errors.startingHour?.message}
          >
            <Controller
              name="startingHour"
              control={formControl}
              render={({ field }) => (
                <TimeSelectInput
                  label=""
                  selectedTime={field.value}
                  onChange={field.onChange}
                />
              )}
            />
          </Field>
          <Field
            label="Heure de clôture"
            required
            error={errors.endingHour?.message}
          >
            <Controller
              name="endingHour"
              control={formControl}
              render={({ field }) => (
                <TimeSelectInput
                  label=""
                  selectedTime={field.value}
                  onChange={field.onChange}
                />
              )}
            />
          </Field>

          <Field
            label="Fermeture des ventes avant l'évènement"
            required
            hint="Durée avant l'heure de début pendant laquelle les billets restent disponibles"
            error={errors.hoursToLeaveOpen?.message}
          >
            <Controller
              name="hoursToLeaveOpen"
              control={formControl}
              render={({ field }) => (
                <TimeSelectInput
                  label=""
                  selectedTime={field.value}
                  onChange={field.onChange}
                  numOfHours={72}
                />
              )}
            />
          </Field>
        </FormSection>

        {/* Location */}
        <FormSection title="Lieu">
          <Field
            label="Ville"
            htmlFor="cityId"
            required
            error={errors.cityId?.message}
          >
            <Controller
              name="cityId"
              control={formControl}
              render={({ field }) => (
                <InfiniteScrollSelect
                  id="cityId"
                  isClearable={false}
                  getOptionLabel={(o: City) => o?.label}
                  getOptionValue={(o: City) => o.id}
                  isOptionSelected={(o: City, selected: City[]) =>
                    o?.id === selected?.[0]?.id
                  }
                  formatOptions={(cities: City[]) =>
                    cities.sort((a, b) =>
                      a.label.localeCompare(b.label, undefined, {
                        sensitivity: "base",
                        usage: "sort",
                      }),
                    )
                  }
                  url={{ path: "cities" }}
                  {...field}
                />
              )}
            />
          </Field>
          <Field
            label="Adresse"
            htmlFor="address"
            required
            error={errors.address?.message}
          >
            <CFormInput
              id="address"
              placeholder="Adresse de l'évènement"
              {...register("address")}
            />
          </Field>
        </FormSection>

        {/* Booking & payment */}
        <FormSection title="Réservation et paiement">
          <Field
            label="Réservation extérieure"
            htmlFor="isExternalBooking"
            error={errors.isExternalBooking?.message}
          >
            <CFormSelect
              id="isExternalBooking"
              {...register("isExternalBooking")}
            >
              <option value="false">Non</option>
              <option value="true">Oui</option>
            </CFormSelect>
          </Field>

          {isExternalBooking ? (
            <Field
              label="URL de réservation"
              htmlFor="externalBookingURL"
              required
              error={errors.externalBookingURL?.message}
            >
              <CFormInput
                id="externalBookingURL"
                type="url"
                placeholder="https://"
                {...register("externalBookingURL")}
              />
            </Field>
          ) : (
            <Field
              col="col-md-6 col-lg-8"
              label="Méthodes de paiement"
              required
            >
              <div className="d-flex flex-wrap gap-2 pt-1">
                <ChipCheck
                  id="paymentMethodsCreditCard"
                  label="Carte bancaire"
                  {...register("paymentMethodsCreditCard")}
                />
                <ChipCheck
                  id="paymentMethodsWafacash"
                  label="Wafacash"
                  {...register("paymentMethodsWafacash")}
                />
                <ChipCheck
                  id="paymentMethodsInPlace"
                  label="Sur place"
                  {...register("paymentMethodsInPlace")}
                />
                <ChipCheck
                  id="paymentMethodsStripe"
                  label="Stripe"
                  {...register("paymentMethodsStripe")}
                />
                <ChipCheck
                  id="paymentMethodsBalance"
                  label="Solde utilisateur"
                  {...register("paymentMethodsBalance")}
                />
              </div>
            </Field>
          )}

          {isAdmin && (
            <>
              <Field
                label="Points"
                htmlFor="points"
                error={errors.points?.message}
              >
                <CFormInput
                  id="points"
                  type="number"
                  step="0.01"
                  {...register("points")}
                />
              </Field>
              <Field
                label="Commission partenaire (%)"
                htmlFor="partnerCommission"
                error={errors.partnerCommission?.message}
              >
                <CFormInput
                  id="partnerCommission"
                  type="number"
                  min={0}
                  max={100}
                  step="0.01"
                  placeholder="Ex : 10"
                  {...register("partnerCommission")}
                />
              </Field>
            </>
          )}
        </FormSection>

        {/* Contact */}
        <FormSection title="Organisateur et réseaux sociaux">
          <Field
            label="E-mail de l'organisateur"
            htmlFor="email"
            required
            error={errors.email?.message}
          >
            <CFormInput id="email" type="email" {...register("email")} />
          </Field>
          <Field
            label="Téléphone de l'organisateur"
            htmlFor="phone"
            required
            error={errors.phone?.message}
          >
            <CFormInput id="phone" type="tel" {...register("phone")} />
          </Field>
          <Field
            label="Site de l'évènement"
            htmlFor="website"
            hint="Ex : https://www.exemple.com"
            error={errors.website?.message}
          >
            <CFormInput
              id="website"
              type="url"
              pattern="https://.*"
              placeholder="https://"
              {...register("website")}
            />
          </Field>
          <Field
            label="Facebook"
            htmlFor="facebookUrl"
            hint="Ex : https://www.facebook.com/exemple"
            error={errors.facebookUrl?.message}
          >
            <CFormInput
              id="facebookUrl"
              type="url"
              pattern="https://.*"
              placeholder="https://"
              {...register("facebookUrl")}
            />
          </Field>
          <Field
            label="Instagram"
            htmlFor="instagramUrl"
            hint="Ex : https://www.instagram.com/exemple"
            error={errors.instagramUrl?.message}
          >
            <CFormInput
              id="instagramUrl"
              type="url"
              pattern="https://.*"
              placeholder="https://"
              {...register("instagramUrl")}
            />
          </Field>
          <Field
            label="TikTok"
            htmlFor="tiktokUrl"
            hint="Ex : https://www.tiktok.com/exemple"
            error={errors.tiktokUrl?.message}
          >
            <CFormInput
              id="tiktokUrl"
              type="url"
              pattern="https://.*"
              placeholder="https://"
              {...register("tiktokUrl")}
            />
          </Field>
        </FormSection>

        {/* Description */}
        <FormSection title="Description">
          <div className="col-12">
            <RichTextEditor
              defaultValue={description}
              onChange={(data) => {
                setDescription(data);
                setFormValue("description", data);
              }}
            />
          </div>
        </FormSection>

        {/* Admin configuration */}
        {isAdmin && (
          <FormSection title="Configuration">
            <Field
              col="col-md-6 col-lg-4"
              label="Pourcentage Venez"
              htmlFor="venezPercentage"
              error={errors.venezPercentage?.message}
            >
              <CFormInput
                id="venezPercentage"
                type="number"
                placeholder="%"
                {...register("venezPercentage")}
              />
            </Field>
          </FormSection>
        )}

        {/* Taxi */}
        {isAdmin && (
          <FormSection title="Configuration taxi">
            <Field
              label="Taxi actif"
              htmlFor="taxiActive"
              error={errors.taxiActive?.message}
            >
              <CFormSelect id="taxiActive" {...register("taxiActive")}>
                <option value="false">Non</option>
                <option value="true">Oui</option>
              </CFormSelect>
            </Field>
            <Field
              label="Adresse taxi"
              htmlFor="addressName"
              required={taxiOn}
              error={errors.addressName?.message}
            >
              <input
                id="addressName"
                className="form-control"
                placeholder="Adresse"
                {...register("addressName")}
              />
            </Field>
            <Field
              label="Latitude"
              htmlFor="latitude"
              required={taxiOn}
              error={errors.latitude?.message}
            >
              <input
                id="latitude"
                type="number"
                className="form-control"
                step="0.0000000001"
                {...register("latitude")}
              />
            </Field>
            <Field
              label="Longitude"
              htmlFor="longitude"
              required={taxiOn}
              error={errors.longitude?.message}
            >
              <input
                id="longitude"
                type="number"
                className="form-control"
                step="0.0000000001"
                {...register("longitude")}
              />
            </Field>
          </FormSection>
        )}

        {/* Tickets */}
        <section
          style={{
            backgroundColor: "#fff",
            borderRadius: 16,
            padding: "18px 20px",
            boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
          }}
          className="mb-3"
        >
          <div
            className="d-flex justify-content-between align-items-center mb-3 pb-2"
            style={{ borderBottom: "1px solid #f0f0f0" }}
          >
            <h6 className="fw-bold mb-0" style={{ fontSize: 15 }}>
              Billets d'événement{" "}
              {eventTicketsFields.length > 0 &&
                `(${eventTicketsFields.length})`}
            </h6>
            <button
              type="button"
              className="btn btn-sm btn-outline-primary rounded-pill px-3"
              onClick={() => appendEventTicketsField("")}
            >
              + Ajouter une date
            </button>
          </div>

          {eventTicketsFields.length === 0 && (
            <div
              className="text-center text-muted py-3"
              style={{
                border: "1px dashed #ddd",
                borderRadius: 12,
                fontSize: 13,
              }}
            >
              Aucune date de billet
            </div>
          )}

          <div className="row g-3">
            {eventTicketsFields.map((ticket, index) => (
              <div className="col-md-6" key={ticket.id}>
                <label
                  htmlFor={`ticketDate-${index}`}
                  className="d-block mb-1 fw-semibold"
                  style={{ fontSize: 13 }}
                >
                  Date de billet {index + 1}{" "}
                  <span style={{ color: "#dc3545" }}>*</span>
                </label>
                <div className="d-flex gap-2">
                  <CFormInput
                    id={`ticketDate-${index}`}
                    type="date"
                    {...register(`ticketsDates[${index}]`)}
                  />
                  <button
                    type="button"
                    className="btn btn-outline-danger rounded-pill px-3"
                    onClick={() => removeEventTicketsField(index)}
                  >
                    Retirer
                  </button>
                </div>
                {errors.ticketsDates?.[index]?.message && (
                  <div
                    style={{ color: "#dc3545", fontSize: 12 }}
                    className="mt-1"
                  >
                    {errors.ticketsDates[index].message}
                  </div>
                )}
              </div>
            ))}
          </div>
        </section>

        {/* Sticky actions */}
        <div
          className="d-flex justify-content-end gap-2 py-3 px-3 mt-3"
          style={{
            position: "sticky",
            bottom: 0,
            zIndex: 5,
            backgroundColor: "#fff",
            borderRadius: 16,
            boxShadow: "0 -4px 16px rgba(0,0,0,0.06)",
          }}
        >
          <Link
            to="/events"
            className="btn btn-outline-secondary rounded-pill px-4"
          >
            Annuler
          </Link>
          <button
            type="submit"
            disabled={formLoading}
            className="btn btn-success text-white rounded-pill px-4"
          >
            {formLoading ? <CSpinner size="sm" /> : "Enregistrer"}
          </button>
        </div>
      </form>
    </div>
  );
}
